import { LoadingButton } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography,
  useMediaQuery
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { useState } from "react";
import InitialsAvatar from "../../common/InitialsAvatar";
// import InboundForm from "./InboundForm";
import PrintForm from "./PrintForm";
import RePrintForm from "./RePrintForm";
import BsModal from "../../common/BaseModal";
import SkeletonLoader from "../../../../utilites/SkeltonLoader";
import { qrGenerationIsLoading } from "../../../slices/QRCode";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {capitalizeWords} from "../../../../utils/utils";

const LmsKitLabel = ({
  patientInfo,
  screenType = "qr-code",
  patientMedicalInfo = {},
  qrCodeId,
  bagCount = false,
  handlePrint,
  getTimeLine,
}) => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const isLoading = useSelector(qrGenerationIsLoading);
  const isRePrint = !!bagCount;
  const [open, setOpen] = useState(false);
  const isTablet = useMediaQuery("(min-width: 1024px) and (max-width: 1360px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const LoginData = useSelector((state) => state.loginData);
  const role_slug = LoginData.role_slug;
  const handlePrintClick = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const isPrintOn = screenType == "qr-code";
  const navigate = useNavigate();
  const avatarSize = isMobile ? 32 : isTablet ? 40 : 50;
  // const fontSize = isMobile ? 14 : 16;
const handleVisitUrl = () =>{
  let url = '';
  if(role_slug == 'superadmin')
    url = `/products/product-details/${patientInfo?.product_id}/patient-details/${patientInfo?.id}`
  if(role_slug == 'editor' || role_slug == 'project-manager')
    url = `/phases/phase-details/${patientInfo?.phase_id}/patient-details/${patientInfo?.id}`
  if(role_slug == 'medical-advisor')
    url = `/bmr/feasibility-assessment/subjects/details/${patientInfo?.id}`
   navigate(url)
} 
  return (
    <Box className="mb-6 mt-4 flex flex-col justify-between h-auto overflow-hidden">
      <Card className="shadow-none flex-grow">
        <CardContent className="flex flex-col h-full">
          <Grid container spacing={2} className="flex-grow">
            <Grid
              item
              xs={12}
              md={12}
              className="relative flex flex-col justify-between"
            >
              {/* Patient Info */}
              <Grid container spacing={2} alignItems="center" className="my-2">
                <Grid item>
                  {!isLoading ? (
                    <InitialsAvatar
                      bgcolor="#D5DCF4"
                      color="#3571FF"
                      size={avatarSize}
                      fontSize={isTablet ? 16 : 20}
                      fontWeight={700}
                    >
                      {capitalizeWords(patientInfo?.patientName)}
                    </InitialsAvatar>
                  ) : (
                    <Skeleton
                      variant="circular"
                      width={avatarSize}
                      height={avatarSize}
                    />
                  )}
                </Grid>
                <Grid item>
                  {!isLoading ? (
                    <>
                      <div>
                        <Typography className="font-roboto font-normal text-sm text-black opacity-50">
                          {patientInfo?.immunoactPatientId}
                        </Typography>
                        <Typography className="font-roboto font-bold text-base">
                          {capitalizeWords(patientInfo?.patientName) ?? (
                            <SkeletonLoader height={16} width={200} />
                          )}
                        </Typography>
                        {['editor','superadmin','medical-advisor','project-manager']?.includes(role_slug) && 
                     <a 
                      className="font-medium  hover:text-blue-800 underline hover:underline cursor-pointer textModifyColor"
                       onClick={() => handleVisitUrl()}
                      > Visit To Pre-Screening Form
                      </a>}
                      </div>
                     
                  </>
                  ) : (
                    <div className="flex ml-3 flex-col">
                      <SkeletonLoader height={16} width={200} rowCount={2} />
                    </div>
                  )}
                </Grid>
              </Grid>

              {/* Medical Info + QR */}
              <Grid container spacing={2} className="flex-grow">
                <Grid item xs={12} md={8}>
                  {isLoading ? (
                    <Grid container spacing={2}>
                      {Array.from({ length: 8 }).map((_, index) => (
                        <Grid item xs={6} key={index}>
                          <Typography className="text-xs text-black opacity-50">
                            <SkeletonLoader height={16} width={100} />
                          </Typography>
                          <Typography className="text-xs">
                            <SkeletonLoader height={16} width={150} />
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Grid container spacing={2}>
                      {Object.entries(patientMedicalInfo).map(
                        ([key, value], index) => (
                          <Grid item xs={6} key={index}>
                            <Typography className="text-xs text-black opacity-50">
                              {key}
                            </Typography>
                            <Typography className="text-xs">{value}</Typography>
                          </Grid>
                        )
                      )}
                    </Grid>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  className="flex justify-center md:mt-0"
                >
                  {isLoading ? (
                    <div className="flex flex-col">
                      <SkeletonLoader height={40} width={150} rowCount={3} />
                    </div>
                  ) : (
                    <QRCodeCanvas
                      style={{
                        width: isTablet ? 120 : 144,
                        height: isTablet ? 120 : 144,
                      }}
                      value={`${baseUrl}/lsm/qr/${qrCodeId}`}
                    />
                  )}
                </Grid>
              </Grid>

              {/* Print Button */}
              {isPrintOn && (
                <Box className="flex justify-start mt-4">
                  <LoadingButton
                    loading={isLoading}
                    onClick={handlePrintClick}
                    variant="outlined"
                    className="w-full md:w-[150px] h-[40px] rounded-md border-[#3571FF]"
                  >
                    {isRePrint ? "Re-Print" : "Print"}
                  </LoadingButton>
                </Box>
              )}
            </Grid>

            {/* Inbound Form */}
          </Grid>
        </CardContent>
      </Card>

      {/* Print Modal */}
      <BsModal
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleCloseModal}
        title="Print QR Code"
        className="p-4"
      >
        {isRePrint ? (
          <RePrintForm
            qrCodeId={qrCodeId}
            bagCount={bagCount}
            handleCloseModal={handleCloseModal}
            handlePrint={handlePrint}
          />
        ) : (
          <PrintForm 
            qrCodeId={qrCodeId}
            handleCloseModal={handleCloseModal}
            handlePrint={handlePrint}
            getTimeLine={getTimeLine}
          />
        )}
      </BsModal>
    </Box>
  );
};

export default LmsKitLabel;
